import React, { FC } from 'react';
import { useTranslationAPI } from '../../../../translations';
import { PublicJobDetailUnderlinedSection } from '../PublicJobDetailUnderlinedSection';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { isNull } from '../../../../../predicates/type';
import { Badge } from '../../../../../components/Badge';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';

export const PublicJobDetailSkills: FC = () => {
	const { translate } = useTranslationAPI();
	const {
		data: { skills },
	} = usePublicJobDetailDataQuery();

	if (isNull(skills)) return null;

	return (
		<PublicJobDetailUnderlinedSection title={translate(jobModuleCodes.primarySkills)}>
			{skills.tagsRef.map((tag) => (
				<Badge
					gray
					key={tag.id}
				>
					{tag.name}
				</Badge>
			))}
		</PublicJobDetailUnderlinedSection>
	);
};
